export const defaultGiftCardCheckerFormData = { cardNumber: '', pin: '', captcha: undefined };
